import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { configureChatRollout } from '@odo/shared-ui';
import App from './App';
import { ErrorFallback } from './observability/ErrorFallback';
import { initDashboardSentry } from './observability/sentry';
import { initializeErrorHandlers } from './utils/errorHandler';
import './index.css';

initDashboardSentry();
// No toggle UI here, so only { 'v1', false } (V1 only) or { 'v2', false } (V2 only) make sense.
configureChatRollout({ defaultVersion: 'v1', canSwitch: false });
try {
    initializeErrorHandlers('frontend');
} catch {
    /* must never block app startup */
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
const app = (
    <Sentry.ErrorBoundary fallback={ErrorFallback} onReset={() => window.location.reload()}>
        <App />
    </Sentry.ErrorBoundary>
);

root.render(import.meta.env.DEV ? <React.StrictMode>{app}</React.StrictMode> : app);
